import React from "react";
import Image from "next/image";

export function BannerHeader() {
  return (
    <div className="overflow-hidden rounded-3xl border border-indigo-700/70">
      <Image
        src="/headerimage.png"
        alt="New Product Submission header"
        className="block h-auto w-full"
        width={1600}
        height={500}
        priority
      />
    </div>
  );
}
